document.addEventListener('DOMContentLoaded', function() {
  // --- MutationObserver to modify video elements once they are added ---
  var videoObserver = new MutationObserver(function(mutationsList) {
    mutationsList.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeName === 'VIDEO') {
          // Remove the inline playback attribute and unmute
          node.removeAttribute('playsinline');
          node.muted = false;
          // Wait a short moment to ensure the video is ready, then request fullscreen and play.
          setTimeout(function() {
            if (node.requestFullscreen) {
              node.requestFullscreen();
            } else if (node.webkitRequestFullscreen) {
              node.webkitRequestFullscreen();
            } else if (node.webkitEnterFullscreen) {
              node.webkitEnterFullscreen();
            }
            node.play();
          }, 100);
        }
      });
    });
  });
  videoObserver.observe(document.body, { childList: true, subtree: true });
  
  // --- IntersectionObserver to auto-click the deferred media poster for video ---
  const options = {
    root: null,
    threshold: 0.5 // Adjust this value if needed.
  };
  
  const intersectionCallback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Look for a deferred media poster within this slide.
        const posterButton = entry.target.querySelector('.deferred-media__poster');
        // If found and not already triggered...
        if (posterButton && !posterButton.getAttribute('data-triggered')) {
          // Check if this poster is for video.
          // (Adjust the condition if your button text or attributes differ.)
          if (posterButton.innerText.toLowerCase().includes('play video') ||
              (posterButton.getAttribute('aria-label') && posterButton.getAttribute('aria-label').toLowerCase().includes('play video'))
             ) {
            posterButton.setAttribute('data-triggered', 'true'); // Prevent duplicate clicks.
            posterButton.click();
          }
        }
      }
    });
  };
  
  const observer = new IntersectionObserver(intersectionCallback, options);
  
  // Observe each media slide that contains a deferred media poster.
  document.querySelectorAll('.product__media-item').forEach(item => {
    if (item.querySelector('.deferred-media__poster')) {
      observer.observe(item);
    }
  });
});
